// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3Sz8o","errors":"Errors_errors__2QXe0"};